<app-loading *ngIf="viewModel.isLoading$ | async" [options]="viewModel.loadingOpts$ | async"> </app-loading>

<app-required-display-edit-method
  [hidden]="(viewModel.editStep$ | async) !== Types.RequiredDisplaysEditStep.ChooseEditMethod"
  (cancelClicked)="cancel()"
  (editMethodSelected)="viewModel.connectToEditStep($event)">
</app-required-display-edit-method>

<app-edit-collection-edit-required-displays
  [hidden]="(viewModel.editStep$ | async) !== Types.RequiredDisplaysEditStep.ApplyToExisting"
  [requiredDisplayIds]="viewModel.requiredDisplayIds$ | async"
  (cancelClicked)="cancel()">
</app-edit-collection-edit-required-displays>

<app-edit-collection-create-new-display
  [hidden]="(viewModel.editStep$ | async) !== Types.RequiredDisplaysEditStep.NewDisplayDetails"
  (cancelClicked)="cancel()">
</app-edit-collection-create-new-display>

<app-select-locations-for-new-display
  [hidden]="(viewModel.editStep$ | async) !== Types.RequiredDisplaysEditStep.SelectLocations"
  [pendingDisplay]="viewModel.pendingDisplay$ | async"
  (goBack)="viewModel.goBack()"
  (cancelClicked)="cancel()">
</app-select-locations-for-new-display>
